<template>
  <b-table
    :items="itensInner"
    :fields="colunasInner"
    hover
    class="tabela-repeticao"
    :bordered="bordered"
    :foot-clone="mostrarFooter"
  >
    <template v-slot:head()="{ field: {key}}">
      <slot
        :slot-scope="{key}"
        name="headCell"
      />
    </template>

    <template v-slot:cell()="{ value: valor, item, index, field: { key, tipo, classe }}">

      <slot
        v-if="item.emEdicao"
        :slot-scope="{item, key, tipo, classe, index}"
        name="edicao"
      />

      <slot
        v-else
        :slot-scope="{valor, item, key, tipo, index}"
        name="visualizacao"
      />
    </template>

    <template #cell(acoes)="{ item, index }">
      <acoes-linha
        :item="item"
        :index="index"
        :validar="validar"
        :edicao="item.emEdicao"
        :ultimo="(rows - 1) === index"
        @input="salvarLinha"
        @novo="novaLinha"
        @cancelar="cancelarLinha"
        @editar="editarLinha"
        @remover="removerLinha"
      >
        <template v-slot:tagObservacao>
          <b-btn
            v-if="tagServico && item.servico && !item.tagComplemento && !item.emEdicao"
            v-b-tooltip.hover
            variant="none"
            title="Complemento"
            class="btn-outline-success btn-none rounded-pill icone-acao margin-icone-acao"
            @click="abrirModalObs(index)"
          >
            <feather-icon
              style=""
              icon="TagIcon"
            />
          </b-btn>
        </template>
      </acoes-linha>
    </template>

    <template v-slot:foot()="{ field: { key }}">
      <slot
        :slot-scope="{key}"
        name="footTotal"
      />
    </template>
  </b-table>
</template>

<style lang="scss">
.tabela-repeticao {
  .form-control {
    padding: 0.438rem 0.7rem;
    height: 2.5rem;
  }

  th {
    background-color: var(--table-bg) !important;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }

  .table-hover {
    tr {
      cursor: default !important;
    }
  }
}
</style>

<script>

export default {
  name: 'TabelaRepeticao',
  components: {
    AcoesLinha: () => import('./shared/components/AcoesLinha.vue'),
  },
  props: {
    colunas: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    validar: {
      type: Function,
      default: null,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    mostrarFooter: {
      type: Boolean,
      default: false,
    },
    tagServico: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colunasInner: [],
      itensInner: [],
    }
  },
  computed: {
    rows() {
      return this.itensInner.length
    },
  },
  watch: {
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.itensInner = value
        if (this.itensInner.length === 0) {
          this.novaLinha({ code: null, emEdicao: true })
        }
      }
    },
  },
  created() {
    this.colunasInner = [...this.colunas, { key: 'acoes', label: 'Ações', width: '50px' }]
    this.itensInner = this.value
    if (!this.itensInner || this.itensInner.length === 0) {
      this.novaLinha({ code: null, emEdicao: true })
    }
  },
  methods: {
    linhaEmEdicao(item) {
      return item.edicao
    },
    salvarLinha(item, index) {
      this.$set(this.itensInner, index, item)
      this.$set(this.itensInner[index], 'emEdicao', item.emEdicao)
    },
    novaLinha(item) {
      this.itensInner.push(item)
    },
    cancelarLinha(item, index) {
      this.$set(this.itensInner, index, item)

      if (this.itensInner.length === 0) {
        this.novaLinha({ code: null, emEdicao: true })
      }
    },
    removerLinha(index) {
      if (index >= 0) {
        this.itensInner.splice(index, 1)
      }
      if (this.itensInner.length === 0) {
        this.novaLinha({ code: null, emEdicao: true })
      }

      this.$emit('update-os-constituicao')
    },
    editarLinha(item, index) {
      for (let i = 0; i < this.itensInner.length; i += 1) {
        if (i === index) {
          this.$set(this.itensInner, i, item)
        }
        this.$set(this.itensInner[i], 'emEdicao', i === index)
      }
    },
    abrirModalObs(index) {
      if (this.itensInner[index].servico) {
        this.$emit('open-modalo-obs', index)
      }
    },
  },
}
</script>
